import { sendRequest } from '../../config';

export interface dataLogoutSignos {
    logged_out?: string;
}

export const logoutSignos = async (): Promise<dataLogoutSignos> => {
    const ENDPOINT = 'sso/logout';
    return sendRequest({
        method: 'post',
        path: ENDPOINT,
    });
};